export var valuesPPNCheckSystem = ["None", "PPX", "PPN"];
/*

*/ 
//# sourceMappingURL=PPNCheckSystem.js.map